import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'src/classnames';
import styles from './SubTitle.module.scss';
import { Tag } from '../DynamicTag';

const SubTitle = ({ children, className, type, tagName = 'h2' }) => (
  <Tag className={classnames(styles.subTitle, { [styles.pageSubtitle]: type === 'page' }, className)} tagName={tagName}>
    {children}
  </Tag>
);

SubTitle.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  type: PropTypes.oneOf(['page', 'common']),
};

SubTitle.defaultProps = {
  type: 'page',
};

export default SubTitle;
